module.exports = __webpack_public_path__ + "static/media/nasolabial_left.fe08018b.svg";